import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '深圳鸿瑞达信息技术有限公司'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '产品&解决方案'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '产品'
              }
            },
            {
              path: '/software/ssd',
              name: 'software',
              component: resolve => require(['@/view/Software_ssd'], resolve),
              meta: {
                title: 'MAC4 SSD'
              }
            },
            {
              path: '/software/m4pro',
              name: 'software',
              component: resolve => require(['@/view/Software_m4pro'], resolve),
              meta: {
                title: 'MAC4 Pro SSD'
              }
            },
            {
              path: '/software/udimm',
              name: 'software',
              component: resolve => require(['@/view/Software_UDIMM'], resolve),
              meta: {
                title: 'UDIMM'
              }
            },
            {
              path: '/software/sodimm',
              name: 'software',
              component: resolve => require(['@/view/Software_SODIMM'], resolve),
              meta: {
                title: 'SODIMM'
              }
            },
            {
              path: '/software/adapter_udimm',
              name: 'software',
              component: resolve => require(['@/view/Software_udimm_card'], resolve),
              meta: {
                title: 'UDIMM转SODIMM'
              }
            },
            {
              path: '/software/adapter_sodimm',
              name: 'software',
              component: resolve => require(['@/view/Software_sodimm_card'], resolve),
              meta: {
                title: 'UDIMM5.0转接卡'
              }
            },
            {
              path: '/software/adapter_pxe',
              name: 'software',
              component: resolve => require(['@/view/Software_pxe_card'], resolve),
              meta: {
                title: 'PXE转接卡'
              }
            },
            {
              path: '/software/B760',
              name: 'software',
              component: resolve => require(['@/view/Software_B760'], resolve),
              meta: {
                title: 'B760超频主板'
              }
            },
            {
              path: '/software/bigData',
              name: 'solution',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '解决方案'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js